import React from 'react';
import './index.scss';

interface EmptyDataProps {
  emptyImg?: string;
  height?: number;
}

export function EmptyData(props: EmptyDataProps = {}) {
  return (
    <div
      className="empty-data"
      style={{ textAlign: 'center', padding: '16px 0', height: props.height || 'auto' }}
    >
      <img src={props.emptyImg} alt="" />
      <div style={{ paddingTop: '10px' }}>暂无数据</div>
    </div>
  );
}
